"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClosedSessionsMobileData = void 0;
var react_1 = require("react");
var date_fns_1 = require("date-fns");
// import { ClosedSession } from '@l2p/profile-api'
var useClosedSessionsMobileData = function (data) {
    return (0, react_1.useMemo)(function () {
        return (data === null || data === void 0 ? void 0 : data.map(function (item) {
            var closedAt = item.closedAt, ip = item.ip, agent = item.agent;
            return {
                date: (0, date_fns_1.format)(new Date(closedAt), 'HH:mm, dd-LL-yy'),
                ip: ip,
                agent: agent,
            };
        })) || [];
    }, [data]);
};
exports.useClosedSessionsMobileData = useClosedSessionsMobileData;
